<template>
  <AdminBackground>
    <div class="image-wrapper">
      <img
        src="@/assets/header/KAMPUNG BARU.png"
        alt="KAMPUNG BARU"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>Maklumat Projek dan Program</h2>
      <div class="spah">
        <div
          v-for="(item, index) in projectData"
          :key="index"
          class="kampung-container"
        >
          <img
            src="@/assets/spah/box.png"
            alt="Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ item.title }}</h3>
              <p class="number">
                {{ item.value }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <Update />
    </div>

    <div class="content-wrapper">
      <h2>Maklumat Kampung</h2>
      <div class="kampung1">
        <!-- First Row - Single Box -->
        <div class="kampung1-container wide">
          <img
            src="@/assets/spah/box.png"
            alt="Premis Persendirian"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>
                Jumlah Kampung
              </h3>
              <p class="number">
                613
              </p>
            </div>
          </div>
        </div>

        <!-- Second Row - Two Boxes Side by Side -->
        <div class="kampung1-row">
          <div class="kampung1-container">
            <img
              src="@/assets/spah/box.png"
              alt="Bilangan Kampung Baru"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>Bilangan Kampung Baru</h3>
                <p class="number">
                  436
                </p>
              </div>
            </div>
          </div>

          <div class="kampung1-container">
            <img
              src="@/assets/spah/box.png"
              alt="Bilangan Kampung Baru Rangkaian"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>Bilangan Kampung Baru Rangkaian</h3>
                <p class="number">
                  134
                </p>
              </div>
            </div>
          </div>

          <div class="kampung1-container">
            <img
              src="@/assets/spah/box.png"
              alt="Bilangan Kampung Bagan"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>Bilangan Kampung Bagan</h3>
                <p class="number">
                  43
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>
  </AdminBackground>
  <PrimaryModule />
  <KampungBaruMenu />
</template>

<script setup>
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const selectedsState = ref('Semua Negeri')
const states = ref(['Semua Negeri', 'Kuala Lumpur', 'Pahang'])
const selectedYear = ref(2024)
const years = ref(['2021', '2020', '2019'])

const projectData = ref([
  { title: 'Bilangan Projek Lulus', value: 585 },
  { title: 'Bilangan Program Komuniti Lulus', value: 320 },
  { title: 'Bilangan Geran Social Ekonomi', value: 320 },
  { title: 'Bilangan Projek Baik Pulih yang Lulus', value: 320 },
  { title: 'Bilangan Bina Baru Rumah Lulus', value: 320 },
])
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}

h3 {
  position: relative;
  display: flex;
  align-items: center;
  color: #000;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  inline-size: 160px;
  margin-block-start: 10px;
  text-align: start;
}

.content-wrapper1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-radius: 20px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 800px;
}

.date-label-container {
  flex-grow: 1;
}


.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}


h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
}


.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%;
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

.spah {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  grid-gap: 10px; /* Gap between the rows and columns */
}

.kampung-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}


.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center;
}

.values-layered h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #150069;
  text-align:center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.kampung1 {
  display: flex;
  flex-direction: column;
  grid-gap: 20px;
  margin-top: 20px;
}

.kampung1-container.wide {
  width: 45%; 
  margin: 0 auto;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}


.kampung1-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.kampung1-container {
  width: 48%; 
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}


@media (max-width: 1024px) {
  .content-wrapper {
    max-inline-size: 1000px;
  }

  .pbt-image {
    max-inline-size: 80%;
  }

  .spah {
    grid-template-columns: repeat(2, 1fr); 
  }

  h2 {
    font-size: 1.8rem;
  }
}


@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .pbt-image {
    max-inline-size: 85%;
  }

  .content-wrapper1 {
    flex-direction: column;
    gap: 10px;
  }

  .spah {
    grid-template-columns: 1fr; 
  }

  h2 {
    font-size: 1.5rem;
    text-align: left;
  }

  h3 {
    font-size: 1rem;
  }

  .number {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .pbt-image {
    max-inline-size: 90%;
  }

  h2 {
    font-size: 1.2rem;
  }

  h3 {
    font-size: 0.9rem;
  }

  .spah {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .number {
    font-size: 18px;
  }
}
</style>
